import { chartSpacing, addSpaceForAnnotations } from './spacing';
import * as chart from './chart';
import * as legend from './legend';
import * as tooltips from './tooltips';
import * as axes from './axes';
import * as recessions from './recessions';
import * as annotations from './annotations';


/**
 * The Inner Chart renders the actual chart sans headlines or footnotes.
 */
export function preRender(options) {
  let data = {
    exporting: {
      enabled: false,
    },
    series: options.series,
    chart: {
      reflow: false,
      type: options.type,
      width: options.width,
      height: options.height,
      style: options.styles.base,
      renderTo: options.el.querySelector('.dj-chart-inner'),
      backgroundColor: 'transparent',
      // backgroundColor: 'rgba(255, 0, 0, 0.1)'
    },
    credits: { enabled: false },
    title: { text: null },
    legend: { enabled: false },
    plotOptions: {},
    xAxis: {},
    yAxis: {}
  };

  data.chart.spacing = chartSpacing(options);
  const isSmallMW = options.product === 'marketwatch' && (options.size === 'marketwatch-ZR' || options.size === 'marketwatch-ZT' || options.size === 'thumb-marketwatch-MA');
  // only invoke addSpaceForAnnotations for charts that can't be found in isSmallMW variable
  if (!isSmallMW) {
    data.chart.spacing = addSpaceForAnnotations(data.chart.spacing, options);
  }
  
  data.plotOptions[options.type] = {};
  data = chart.preRender(data, options);
  const isZR = options.product === 'marketwatch' && options.size === 'marketwatch-ZR';
  if (options.size.indexOf('thumb') === 0 || isZR) {
    data.plotOptions.series = data.plotOptions.series || {}
    data.plotOptions.series.enableMouseTracking = false;
    data.xAxis.visible = data.yAxis.visible = false;
    data.yAxis.gridLineWidth = data.xAxis.gridLineWidth = 0;
  } else {
    data = legend.preRender(data, options);
    data = tooltips.preRender(data, options);
    data = axes.preRender(data, options);
    data = recessions.preRender(data, options);
  }

  return data;
}

export function postRender(highchart, options) {
  chart.postRender(highchart, options);
  const isZR = options.product === 'marketwatch' && options.size === 'marketwatch-ZR';
  if (options.size.indexOf('thumb') === 0 || isZR) {
    if (__MARKETWATCH__) {
      if (options.type !== 'bar') {
        let topEl = options.el.lastChild.lastChild.lastChild.lastChild;
        let firstChildThumb = topEl.firstChild;
        let secondChildThumb = topEl.lastChild;
        firstChildThumb.transform.baseVal.getItem(0).setTranslate(0, 0);
        firstChildThumb.transform.baseVal.getItem(0).setTranslate(0, 0);
      }
    }
  } else {
    legend.postRender(highchart, options);
    tooltips.postRender(highchart, options);
    axes.postRender(highchart, options);
    recessions.postRender(highchart, options);
    annotations.postRender(highchart, options);
  }
}

export function renderInvalidated(rendered, options, invalidated) {
  if (__ALL__) {
    chart.renderInvalidated(rendered, options, invalidated);
  }
}



// WEBPACK FOOTER //
// ./src/chart/inner/index.js